import * as tslib_1 from "tslib";
import * as React from 'react';
import { NotificationToast, headerToastNotificationStore } from 'owa-header-toast-notification';
import { observer } from 'mobx-react';
import { NotificationPane } from 'owa-header-app-notifications';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { mergeStyles } from '@uifabric/merge-styles';
import { Layer } from 'office-ui-fabric-react/lib/Layer';
// #24738 - We should move owa-header-toast-notification to owa-header-app-notifications and unify on a design
// For now, this merges the two together.
export default observer(function MergedNotificationPane(props) {
    if (isControlFeatureEnabled('fwk-inAppNotifications')) {
        return React.createElement(NotificationPane, tslib_1.__assign({}, props), getHeaderToasts());
    }
    else {
        // This branch will be eliminated once #24738 is addressed and `owa-header-toast-notification` is
        // rolled into `owa-header-app-notifications`.
        return (React.createElement(Layer, null,
            React.createElement("div", { className: mergeStyles(tslib_1.__assign({}, props.offset, { position: 'absolute' })) }, getHeaderToasts())));
    }
});
function getHeaderToasts() {
    return headerToastNotificationStore.notificationViewStates.map(function (notification) { return (React.createElement(NotificationToast, { notification: notification, key: notification.id })); });
}
//# sourceMappingURL=MergedNotificationPane.js.map